import _classCallCheck from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { Buffer } from "buffer";
import { generateKeypair, isValidPublicKey } from "../utils";
import { AbstractHandshake } from "./abstract-handshake";
export var IK = /*#__PURE__*/function (_AbstractHandshake) {
  _inherits(IK, _AbstractHandshake);

  var _super = _createSuper(IK);

  function IK() {
    _classCallCheck(this, IK);

    return _super.apply(this, arguments);
  }

  _createClass(IK, [{
    key: "initSession",
    value: function initSession(initiator, prologue, s, rs) {
      var psk = this.createEmptyKey();
      var hs;

      if (initiator) {
        hs = this.initializeInitiator(prologue, s, rs, psk);
      } else {
        hs = this.initializeResponder(prologue, s, rs, psk);
      }

      return {
        hs: hs,
        i: initiator,
        mc: 0
      };
    }
  }, {
    key: "sendMessage",
    value: function sendMessage(session, message) {
      var messageBuffer;

      if (session.mc === 0) {
        messageBuffer = this.writeMessageA(session.hs, message);
      } else if (session.mc === 1) {
        var _this$writeMessageB = this.writeMessageB(session.hs, message),
            mb = _this$writeMessageB.messageBuffer,
            h = _this$writeMessageB.h,
            cs1 = _this$writeMessageB.cs1,
            cs2 = _this$writeMessageB.cs2;

        messageBuffer = mb;
        session.h = h;
        session.cs1 = cs1;
        session.cs2 = cs2;
      } else if (session.mc > 1) {
        if (session.i) {
          if (!session.cs1) {
            throw new Error("CS1 (cipher state) is not defined");
          }

          messageBuffer = this.writeMessageRegular(session.cs1, message);
        } else {
          if (!session.cs2) {
            throw new Error("CS2 (cipher state) is not defined");
          }

          messageBuffer = this.writeMessageRegular(session.cs2, message);
        }
      } else {
        throw new Error("Session invalid.");
      }

      session.mc++;
      return messageBuffer;
    }
  }, {
    key: "recvMessage",
    value: function recvMessage(session, message) {
      var plaintext = Buffer.alloc(0),
          valid = false;

      if (session.mc === 0) {
        var _this$readMessageA = this.readMessageA(session.hs, message);

        plaintext = _this$readMessageA.plaintext;
        valid = _this$readMessageA.valid;
      }

      if (session.mc === 1) {
        var _this$readMessageB = this.readMessageB(session.hs, message),
            pt = _this$readMessageB.plaintext,
            v = _this$readMessageB.valid,
            h = _this$readMessageB.h,
            cs1 = _this$readMessageB.cs1,
            cs2 = _this$readMessageB.cs2;

        plaintext = pt;
        valid = v;
        session.h = h;
        session.cs1 = cs1;
        session.cs2 = cs2;
      }

      session.mc++;
      return {
        plaintext: plaintext,
        valid: valid
      };
    }
  }, {
    key: "writeMessageA",
    value: function writeMessageA(hs, payload) {
      hs.e = generateKeypair();
      var ne = hs.e.publicKey;
      this.mixHash(hs.ss, ne);
      this.mixKey(hs.ss, this.dh(hs.e.privateKey, hs.rs));
      var spk = Buffer.from(hs.s.publicKey);
      var ns = this.encryptAndHash(hs.ss, spk);
      this.mixKey(hs.ss, this.dh(hs.s.privateKey, hs.rs));
      var ciphertext = this.encryptAndHash(hs.ss, payload);
      return {
        ne: ne,
        ns: ns,
        ciphertext: ciphertext
      };
    }
  }, {
    key: "writeMessageB",
    value: function writeMessageB(hs, payload) {
      hs.e = generateKeypair();
      var ne = hs.e.publicKey;
      this.mixHash(hs.ss, ne);
      this.mixKey(hs.ss, this.dh(hs.e.privateKey, hs.re));
      this.mixKey(hs.ss, this.dh(hs.e.privateKey, hs.rs));
      var ciphertext = this.encryptAndHash(hs.ss, payload);
      var ns = this.createEmptyKey();
      var messageBuffer = {
        ne: ne,
        ns: ns,
        ciphertext: ciphertext
      };

      var _this$split = this.split(hs.ss),
          cs1 = _this$split.cs1,
          cs2 = _this$split.cs2;

      return {
        messageBuffer: messageBuffer,
        cs1: cs1,
        cs2: cs2,
        h: hs.ss.h
      };
    }
  }, {
    key: "readMessageA",
    value: function readMessageA(hs, message) {
      if (isValidPublicKey(message.ne)) {
        hs.re = message.ne;
      }

      this.mixHash(hs.ss, hs.re);
      this.mixKey(hs.ss, this.dh(hs.s.privateKey, hs.re));

      var _this$decryptAndHash = this.decryptAndHash(hs.ss, message.ns),
          ns = _this$decryptAndHash.plaintext,
          valid1 = _this$decryptAndHash.valid;

      if (valid1 && ns.length === 32 && isValidPublicKey(ns)) {
        hs.rs = ns;
      }

      this.mixKey(hs.ss, this.dh(hs.s.privateKey, hs.rs));

      var _this$decryptAndHash2 = this.decryptAndHash(hs.ss, message.ciphertext),
          plaintext = _this$decryptAndHash2.plaintext,
          valid2 = _this$decryptAndHash2.valid;

      return {
        plaintext: plaintext,
        valid: valid1 && valid2
      };
    }
  }, {
    key: "readMessageB",
    value: function readMessageB(hs, message) {
      if (isValidPublicKey(message.ne)) {
        hs.re = message.ne;
      }

      this.mixHash(hs.ss, hs.re);

      if (!hs.e) {
        throw new Error("Handshake state should contain ephemeral key by now.");
      }

      this.mixKey(hs.ss, this.dh(hs.e.privateKey, hs.re));
      this.mixKey(hs.ss, this.dh(hs.s.privateKey, hs.re));

      var _this$decryptAndHash3 = this.decryptAndHash(hs.ss, message.ciphertext),
          plaintext = _this$decryptAndHash3.plaintext,
          valid = _this$decryptAndHash3.valid;

      var _this$split2 = this.split(hs.ss),
          cs1 = _this$split2.cs1,
          cs2 = _this$split2.cs2;

      return {
        h: hs.ss.h,
        valid: valid,
        plaintext: plaintext,
        cs1: cs1,
        cs2: cs2
      };
    }
  }, {
    key: "initializeInitiator",
    value: function initializeInitiator(prologue, s, rs, psk) {
      var name = "Noise_IK_25519_ChaChaPoly_SHA256";
      var ss = this.initializeSymmetric(name);
      this.mixHash(ss, prologue);
      this.mixHash(ss, rs);
      var re = Buffer.alloc(32);
      return {
        ss: ss,
        s: s,
        rs: rs,
        re: re,
        psk: psk
      };
    }
  }, {
    key: "initializeResponder",
    value: function initializeResponder(prologue, s, rs, psk) {
      var name = "Noise_IK_25519_ChaChaPoly_SHA256";
      var ss = this.initializeSymmetric(name);
      this.mixHash(ss, prologue);
      this.mixHash(ss, s.publicKey);
      var re = Buffer.alloc(32);
      return {
        ss: ss,
        s: s,
        rs: rs,
        re: re,
        psk: psk
      };
    }
  }]);

  return IK;
}(AbstractHandshake);